module.exports = __webpack_public_path__ + "static/media/material-ui-1.82291019.svg";